// Tries to apply every ARIA attribute and other attributes for accessibility
const addAccessibility = (props) => {
  return {
    'aria-autocomplete': props['aria-autocomplete'],
    'aria-checked': props['aria-checked'],
    'aria-disabled': props['aria-disabled'],
    'aria-expanded': props['aria-expanded'],
    'aria-haspopup': props['aria-haspopup'],
    'aria-hidden': props['aria-hidden'],
    'aria-invalid': props['aria-invalid'],
    'aria-label': props['aria-label'],
    'aria-level': props['aria-level'],
    'aria-multiline': props['aria-multiline'],
    'aria-multiselectable': props['aria-multiselectable'],
    'aria-orientation': props['aria-orientation'],
    'aria-pressed': props['aria-pressed'],
    'aria-readonly': props['aria-readonly'],
    'aria-required': props['aria-required'],
    'aria-selected': props['aria-selected'],
    'aria-sort': props['aria-sort'],
    'aria-valuemax': props['aria-valuemax'],
    'aria-valuemin': props['aria-valuemin'],
    'aria-valuenow': props['aria-valuenow'],
    'aria-valuetext': props['aria-valuetext'],
    'aria-atomic': props['aria-atomic'],
    'aria-busy': props['aria-busy'],
    'aria-live': props['aria-live'],
    'aria-relevant': props['aria-relevant'],
    'aria-dropeffect': props['aria-dropeffect'],
    'aria-grabbed': props['aria-grabbed'],
    'aria-activedescendant': props['aria-activedescendant'],
    'aria-controls': props['aria-controls'],
    'aria-describedby': props['aria-describedby'],
    'aria-flowto': props['aria-flowto'],
    'aria-labelledby': props['aria-labelledby'],
    'aria-owns': props['aria-owns'],
    'aria-posinset': props['aria-posinset'],
    'aria-setsize': props['aria-setsize'],
    role: props.role,
    tabIndex: props.tabindex,
  };
};

export default addAccessibility;
